'use client'

import { Button } from '@/packages/news-ui/basic/button'
import taongaSwirlWhiteIcon from '@/shared/assets/taongaSwirlWhite.svg'
import { getPublicEnv } from '@/shared/env'
import { useI18n } from '@/shared/providers'

export function PlayButton() {
    const runtimeEnv = getPublicEnv()
    const { i18n } = useI18n()

    return (
        <Button
            color="primary"
            size="sm"
            onClick={() => {
                window.location.href = `${runtimeEnv.NEXT_PUBLIC_TAONGA_PORTAL_URL}/play`
            }}
        >
            <img src={taongaSwirlWhiteIcon.src} height="16" width="16" alt="play" style={{ marginTop: '-3px' }} />
            &nbsp;{i18n.BUTTON_PLAY.toUpperCase()}
        </Button>
    )
}
